import Button from '@mui/material/Button';
import { useTheme } from "@mui/material";


export default function ButtonsMain({ name, action, sx: sxOverride, ...props  }) {

  const theme = useTheme();

  return (

    theme.palette.mode === "light" ? (

      <Button variant="outlined" size="large" onClick={action} {...props}

                sx={[{

                  minWidth: {xs: 80, sm: 90, md: 100, lg: 100, xl: 100},
                  mt:1,
                  p: '10px 12px',
                  color: 'grey.C10',
                  bgcolor: 'greydark.C900',
                  borderColor: 'greydark.C900',
                  borderRadius: '20px',
                  transition: 'transform 0.2s ease',

                  '&:hover': {
                  color: 'grey.C10',
                  bgcolor: 'greydark.C900',
                  borderColor: 'greydark.C900',
                  borderRadius: '20px',
                  transform: 'scale(1.2)',
                  },

                  '&.Mui-disabled': {
                    color: 'grey.600',
                    bgcolor: 'grey.300',
                    borderColor: 'grey.300',
                  },

                }, sxOverride]}>
        {name}
      </Button>

  ) : (


    <Button variant="outlined" size="large" onClick={action} {...props}

            sx={[{

                minWidth: {xs: 80, sm: 90, md: 100, lg: 100, xl: 100},
                p: '10px 14px',
                color: 'greydark.C900',
                bgcolor: 'grey.C100',
                borderColor: 'grey.C100',
                borderRadius: '20px',
                transition: 'transform 0.2s ease',

                '&:hover': {
                color: 'greydark.C900',
                bgcolor: 'grey.C100',
                borderColor: 'grey.C100',
                transform: 'scale(1.2)',
                },

                '&.Mui-disabled': {
                  color: 'rgba(255, 255, 255, 0.5)',
                  bgcolor: 'rgba(255, 255, 255, 0.12)',
                  borderColor: 'rgba(255, 255, 255, 0.12)',
                },

              }, sxOverride]}
          >

        {name}

    </Button>
  )
  );
}